import React, { useState, useEffect, useRef } from 'react';
import $ from 'jquery';
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap 5
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; // DataTable Bootstrap 5 Styles
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; // DataTable Bootstrap 5 Responsive
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx'; 
import './index.css';
import Header from '../Header';
import { Button, Spinner } from 'react-bootstrap';

const MyTask = () => {
  const [emp, setEmp] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);  // Selected task for status update
  const [status, setStatus] = useState("");  // Status for the modal
  const [successMessage, setSuccessMessage] = useState(null);
  const tableRef = useRef(null);
  const id = localStorage.getItem('userId');
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
    
  // Fetch employee data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/emptasks/${id}`);        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();  
       console.log(result)
        setEmp(result.task || []);          
      } catch (error) {
        setError(error.message);  
      } finally {
        setLoading(false);  
      }
    };
    fetchData(); 
  }, []);

  // Initialize DataTable after employee data is fetched
  useEffect(() => {
    if (emp.length > 0 && tableRef.current) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true, 
        paging: true,
        pageLength: 10, 
        lengthMenu: [10, 25, 50, 100], 
      });
      return () => {
        table.destroy(); // Cleanup on unmount
      };
    }
  }, [emp]);

  const exportToExcel = () => {
    if (emp.length === 0) {
      alert("No data to export");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(emp);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "emp");
    XLSX.writeFile(wb, "Employee_List.xlsx");
  };

  const handleStatusChange = (task) => {
    setSelectedTask(task);
    setStatus(task.status || ""); // Set current status for the modal
  };

  const updateStatus = async () => {
    if (!selectedTask) return;
  
    const formData = new FormData();
    formData.append('status', status);
    formData.append('emp_query', selectedTask.emp_query);
    formData.append('task_uniqueid', selectedTask.task_uniqueid);
    formData.append('user_id', selectedTask.user_id);
    formData.append(
      'service_id',
      selectedTask.Sname === 'Others' ? selectedTask.other_service_task : selectedTask.Sname
    );
  
    if (selectedFile) {
      formData.append('file', selectedFile);
    }
    
  
    try {
      setIsLoading(true);
  
      const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/Cquery`, {
        method: 'POST',
        body: formData, // No Content-Type; browser sets it automatically for FormData
      });
  
      if (!response.ok) {
        throw new Error('Failed to update status');
      }
  
      const textResponse = await response.text();
      let result = {};
      if (textResponse) {
        result = JSON.parse(textResponse);
      }
  
      const updatedTasks = emp.map((task) =>
        task.id === selectedTask.id
          ? { ...task, status, emp_query: selectedTask.emp_query, user_id: selectedTask.user_id }
          : task
      );
  
      setEmp(updatedTasks || []);
      setSuccessMessage('Query raised successfully');
      setSelectedTask(null);
      setStatus("");
      setSelectedFile(null); // Reset the file
  
      setTimeout(() => setSuccessMessage(null), 3000);
    } catch (error) {
      console.error('Error updating status:', error);
      setError('Failed to update status. Please try again.');
      setSuccessMessage(null);
    } finally {
      setIsLoading(false);
    }
  };
  
  
 

  const handleModalClose = () => {
    setSelectedTask(null);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="shadow mx-1 px-3 bg-light rounded-3">
        <div className="d-flex align-items-center justify-content-between p-3 mt-3">
          <h4 className="mb-0">My Task </h4>
          <button className="btn btn-success" onClick={exportToExcel}>
            Export to Excel
          </button>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}
        {successMessage && <div className="alert alert-success">{successMessage}</div>}
        <div className="card">
          <div className="card-header">Task List</div>
          <div className="card-body">
            <div className="table-responsive">
              <table ref={tableRef} className="table table-striped table-bordered display nowrap"  style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th>S.no</th>                    
                    <th>Task No.</th> 
                    <th>User</th>
                    <th>Plan</th>
                    <th>Task Service</th>
                    <th>Desc</th>
                    <th>Emp Desc</th>
                    <th>Status</th>
                    <th>Action</th>
                    <th>Assigned On</th>
                    <th>Closed On</th>
                    
                  </tr>
                </thead>
                <tbody>
                  {emp.length > 0 ? (
                    emp.map((task, index) => (
                      <tr key={task.id}>
                        <td>{index + 1}</td>
                        <td className="text-danger">{task.task_uniqueid || 'N/A'}</td>
                        <td className="text-primary">{task.Username || 'N/A'}</td>
                        <td>{task.Plan || 'N/A'}</td>
                        <td>{task.Sname === 'Others' ? (
                         task.other_service_task
                        ) : (
                          task.Sname
                        )}                      
                      </td>
                        <td>{task.Task_Description || 'N/A'}</td>
                        <td>{task.Emp_Description || 'N/A'}</td>
                        <td className={task.status === 'open' || task.status === 'in-progress' ? 'text-primary' : 'text-danger'}>
                          {task.status || 'N/A'}
                        </td>
                        <td>                            
                          <button className="btn btn-primary" onClick={() => handleStatusChange(task)} disabled={task.status === 'closed'}> 
                            Raise a Query
                          </button>
                          &nbsp;
                          <button className="btn btn-primary" onClick={() => navigate(`/Quries/${task.task_uniqueid}`)}>
                              View
                          </button>
                        </td>
                        <td>{task.doa || 'N/A'}</td>
                        <td>{task.task_cdate || 'N/A'}</td>                      
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6">No Tasks available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for updating status */}
      {selectedTask && (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="statusModalLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="statusModalLabel">Update Task Status</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleModalClose}></button>
              </div>
              <div className="modal-body">
              <input id="task_uniqueid" className="form-control" type="hidden" value={selectedTask.task_uniqueid || ''} />
              <input id="user_id" name="user_id" className="form-control" type="hidden" value={selectedTask.user_id || ''} />
              <input id="service_task" name="service_task" className="form-control" type="hidden" value={selectedTask.service_task || ''} />
                <div className="mb-3">
                  <label htmlFor="description" className="form-label">Description</label>
                  <textarea id="description" className="form-control" name='description' rows="3" placeholder="Add a description..."                   
                    onChange={(e) =>
                        setSelectedTask((prevState) => ({
                        ...prevState,
                        emp_query: e.target.value,  
                        }))
                    }
                    />
                </div>
                <div className="mb-3">
                  <label htmlFor="file" className="form-label">Attach File</label>
                  <input type="file" className="form-control" id="file"  onChange={(e) => setSelectedFile(e.target.files[0])}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="status" className="form-label">Status</label>
                  <select id="status" className="form-select"  onChange={(e) => setStatus(e.target.value)} required >
                    <option value="">Select Status</option>
                    <option value="in-progress">In Progress</option>
                    <option value="closed">Closed</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleModalClose}>Close</button>
                <button type="button" className="btn btn-primary" onClick={updateStatus}>
                  {isLoading ? (
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Update Status"
                  )}
                  </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MyTask;
